import { Box, Theme, Typography } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { memo } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { makeStyles, createStyles } from '@mui/styles'
import { ISpecialInterestRate } from './typings'

const useStyles = makeStyles<Theme, ISpecialInterestRate>(() =>
  createStyles({
    tooltipContentCls: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: '30%',
    },
    toolTipCls: {
      background: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.bgColor : '',
      color: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.color : '',
    },
  }),
)

const SpecialInterestRateTooltip = (props: ISpecialInterestRate) => {
  const { tooltipContentCls, toolTipCls } = useStyles(
    props || { isSpecial: false },
  )

  return (
    <Tooltip
      title='Diesen Zinsatz erhalten Sie exklusiv nur über uns und nicht bei der Bank selbst.'
      arrow
      placement='top'
      classes={{
        tooltip: toolTipCls,
        arrow: toolTipCls,
      }}
    >
      <Box
        className={tooltipContentCls}
        sx={{ pointerEvents: 'auto' }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <Typography sx={{ fontWeight: 'bold' }}>SONDERZINS</Typography>
        <InfoIcon sx={{ fontSize: 14, margin: '5px' }} />
      </Box>
    </Tooltip>
  )
}

export default memo(SpecialInterestRateTooltip)
